/**
 * WordPress dependencies
 */
import { Button, ButtonGroup } from '@wordpress/components';
import { useState } from '@wordpress/element';
import { __ } from '@wordpress/i18n';
import classNames from 'classnames';

const tabOptions = [
    {
        label: __('Normal', 'faqmate-blocks'),
        value: 'normal'
    },
    {
        label: __('Hover', 'faqmate-blocks'),
        value: 'hover'
    }
];
const SwitcherControl = ({ normal, hover, options = [], className }) => {
    const [tab, setTab] = useState('normal');

    const Tabs = options.length > 0 ? options : tabOptions;

    return (
        <div className={classNames('faqmate-control-container', 'faqmate-switcher', 'faqmate-mb-24', className)}>
            <ButtonGroup>
                {Tabs &&
                    Tabs.map((item, index) => {
                        return (
                            <Button
                                key={index}
                                className={`switcher-button ${tab === item.value ? 'faqmate-active' : ''}`}
                                onClick={() => setTab(item.value)}
                            >
                                {item.label}
                            </Button>
                        );
                    })}
            </ButtonGroup>
            <div className="faqmate-switcher-content">
                {tab === 'normal' && <div className="faqmate-normal-content">{normal}</div>}
                {tab === 'hover' && <div className="faqmate-hover-content">{hover}</div>}
            </div>
        </div>
    );
};

export default SwitcherControl;
